//add class to accessibe widget trigger container to position it correctly on pdp
document.addEventListener('DOMContentLoaded', () => {
  const isMobileDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  };

  const checkAndAddClass = (widget) => {
    if (!widget.shadowRoot) return;
    const triggerElement = widget.shadowRoot.querySelector('[part="acsb-trigger"]');
    if (triggerElement) {
      widget.classList.add('access-button-container');
      if (isMobileDevice()) {
        widget.classList.add('access-button-container-mobile');
      }
      return true;
    }
    return false;
  };
  
  const existingWidgets = document.querySelectorAll('access-widget-ui');
  existingWidgets.forEach(checkAndAddClass);
  
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'ACCESS-WIDGET-UI') {
          const updated = checkAndAddClass(node);
          if (updated) {
            observer.disconnect();
          }
        }
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});